import React, { useState, useEffect } from 'react';
import MetaData from '../../layout/MetaData';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { saveUserAddressInfo, saveGoodsInfo, saveLabour } from '../../../redux/features/userAddressInfoSlice';
import { GOODS_TYPE } from '../../../constants/constants';

const CreateLocalBooking = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [vehicle, setVehicle] = useState('Suzuki');
  const [loadType, setLoadType] = useState('Full Truck');
  const [notes, setNotes] = useState('');
  const [startAddress, setStartAddress] = useState('');
  const [destinationAddress, setDestinationAddress] = useState('');
  const [startCity, setStartCity] = useState('');
  const [destinationCity, setDestinationCity] = useState('');

  const [goodsType, setGoodsType] = useState('Other');
  const [totalWeight, setTotalWeight] = useState('');
  const [volume, setVolume] = useState('');
  const [loadingType, setLoadingType] = useState('Labour');

  const [requiredLaboursStart, setRequiredLaboursStart] = useState('');
  const [noOfLaboursStart, setNoOfLaboursStart] = useState('');
  const [buildingFloorsStart, setBuildingFloorsStart] = useState('');
  const [cargoLiftStart, setCargoLiftStart] = useState('');

  const [requiredLaboursDestination, setRequiredLaboursDestination] = useState('');
  const [noOfLaboursDestination, setNoOfLaboursDestination] = useState('');
  const [buildingFloorsDestination, setBuildingFloorsDestination] = useState('');
  const [cargoLiftDestination, setCargoLiftDestination] = useState('');

  const { userAddressInfo } = useSelector((state) => state.userAddressInfo);
  const { labour } = useSelector((state) => state.userAddressInfo);

  useEffect(() => {
    if (userAddressInfo) {
      if (userAddressInfo.vehicle) setVehicle(userAddressInfo.vehicle);
      if (userAddressInfo.loadType) setLoadType(userAddressInfo.loadType);
      setNotes(userAddressInfo.notes);
      setStartAddress(userAddressInfo.startAddress);
      setDestinationAddress(userAddressInfo.destinationAddress);
      setStartCity(userAddressInfo.startCity);
      setDestinationCity(userAddressInfo.destinationCity);
      if (userAddressInfo.goodsType) setGoodsType(userAddressInfo.goodsType);
      if (userAddressInfo.loadingType) setLoadingType(userAddressInfo.loadingType);
      setTotalWeight(userAddressInfo.totalWeight);
      setVolume(userAddressInfo.volume);
    }
  }, [userAddressInfo]);

  useEffect(() => {
    if (labour) {
      setRequiredLaboursStart(labour.requiredLaboursStart);
      setNoOfLaboursStart(labour.noOfLaboursStart);
      setBuildingFloorsStart(labour.buildingFloorsStart);
      setCargoLiftStart(labour.cargoLiftStart);
      setRequiredLaboursDestination(labour.requiredLaboursDestination);
      setNoOfLaboursDestination(labour.noOfLaboursDestination);
      setBuildingFloorsDestination(labour.buildingFloorsDestination);
      setCargoLiftDestination(labour.cargoLiftDestination);
    }
  }, [labour]);

  const submiHandler = (e) => {
    e.preventDefault();
    dispatch(saveUserAddressInfo({ adminProposedAmount: '', notes, vehicle, loadType, bookingType: 'Local', startAddress, destinationAddress, startCity, destinationCity }));
    dispatch(saveGoodsInfo({ goodsType, totalWeight, loadingType, volume, userProposedAmount: '' }));
    dispatch(saveLabour({ cargoLiftDestination, buildingFloorsDestination, noOfLaboursDestination, requiredLaboursDestination, cargoLiftStart, buildingFloorsStart, noOfLaboursStart, requiredLaboursStart }));
    navigate('/calculate-price');
  };

  return (
    <>
      <MetaData title="Create Local Booking" />
      <div className="row wrapper mb-5">
        <div className="col-10 col-lg-5">
          <form className="shadow rounded bg-body" onSubmit={submiHandler}>
            <h2 className="mb-4 text-center">Local Booking</h2>

            <h4 className="mb-3 text-primary fw-semibold">Vehicle Details</h4>

            <div className="mb-3">
              <label htmlFor="vehicle_field" className="form-label">Vehicle Needed</label>
              <select className="form-select" id="vehicle_field" value={vehicle} onChange={(e) => setVehicle(e.target.value)} required>
                <option value="Suzuki">Suzuki</option>
                <option value="Mazda">Mazda</option>
                <option value="Shehzore">Shehzore</option>
              </select>
            </div>

            <div className="mb-3">
              <label htmlFor="startAddress_field" className="form-label">Starting Address</label>
              <input type="text" id="startAddress_field" className="form-control" value={startAddress} onChange={(e) => setStartAddress(e.target.value)} placeholder="Enter pickup address" required />
            </div>

            <div className="mb-3">
              <label htmlFor="destinationAddress_field" className="form-label">Destination Address</label>
              <input type="text" id="destinationAddress_field" className="form-control" value={destinationAddress} onChange={(e) => setDestinationAddress(e.target.value)} placeholder="Enter delivery address" required />
            </div>

            <div className="row">
              <div className="col-6 mb-3">
                <label htmlFor="startCity_field" className="form-label">Start City</label>
                <input type="text" id="startCity_field" className="form-control" value={startCity} onChange={(e) => setStartCity(e.target.value)} placeholder="City" required />
              </div>
              <div className="col-6 mb-3">
                <label htmlFor="destinationCity_field" className="form-label">Destination City</label>
                <input type="text" id="destinationCity_field" className="form-control" value={destinationCity} onChange={(e) => setDestinationCity(e.target.value)} placeholder="City" required />
              </div>
            </div>

            <hr className="my-4" />

            <h4 className="mb-3 text-primary fw-semibold">Goods Details</h4>

            <div className="row">
              <div className="col-6 mb-3">
                <label htmlFor="goodsType_field" className="form-label">Goods Type</label>
                <select className="form-select" id="goodsType_field" value={goodsType} onChange={(e) => setGoodsType(e.target.value)} required>
                  {GOODS_TYPE?.map((category) => (
                    <option key={category} value={category}>{category}</option>
                  ))}
                </select>
              </div>
              <div className="col-6 mb-3">
                <label htmlFor="loadingType_field" className="form-label">Loading Type</label>
                <select className="form-select" id="loadingType_field" value={loadingType} onChange={(e) => setLoadingType(e.target.value)} required>
                  <option value="Labour">Labour</option>
                  <option value="Lifter">Lifter</option>
                  <option value="Crane">Crane</option>
                </select>
              </div>
            </div>

            <div className="row">
              <div className="col-6 mb-3">
                <label className="form-label">Total Weight (KG)</label>
                <div className="input-group">
                  <span className="input-group-text">KG</span>
                  <input type="number" className="form-control" value={totalWeight} onChange={(e) => setTotalWeight(e.target.value)} placeholder="0" required />
                </div>
              </div>
              <div className="col-6 mb-3">
                <label className="form-label">Volume (m³)</label>
                <div className="input-group">
                  <span className="input-group-text">m³</span>
                  <input type="number" className="form-control" value={volume} onChange={(e) => setVolume(e.target.value)} placeholder="0" required />
                </div>
              </div>
            </div>

            <div className="mb-3">
              <label htmlFor="notes_field" className="form-label">Extra Notes</label>
              <textarea className="form-control" id="notes_field" rows="3" value={notes} onChange={(e) => setNotes(e.target.value)} placeholder="Any special instructions..." />
            </div>

            <hr className="my-4" />

            <h4 className="mb-3 text-primary fw-semibold">Labour — Pickup Address</h4>

            <div className="mb-3">
              <div className="form-check form-switch">
                <input className="form-check-input" type="checkbox" id="requiredLaboursStart_field" checked={requiredLaboursStart} onChange={(e) => setRequiredLaboursStart(e.target.checked)} />
                <label className="form-check-label" htmlFor="requiredLaboursStart_field">
                  {requiredLaboursStart ? 'Labour required: ON' : 'Labour required: OFF'}
                </label>
              </div>
            </div>

            {requiredLaboursStart && (
              <>
                <div className="mb-3">
                  <label className="form-label">Number of Labours</label>
                  <input type="number" className="form-control" value={noOfLaboursStart} onChange={(e) => setNoOfLaboursStart(e.target.value)} required />
                </div>
                <div className="mb-3">
                  <label className="form-label">Loading Floors</label>
                  <input type="number" className="form-control" value={buildingFloorsStart} onChange={(e) => setBuildingFloorsStart(e.target.value)} required />
                </div>
                <div className="mb-3">
                  <label className="form-label">Cargo Lift Available?</label>
                  <div className="form-check form-switch">
                    <input className="form-check-input" type="checkbox" checked={cargoLiftStart} onChange={(e) => setCargoLiftStart(e.target.checked)} />
                  </div>
                </div>
              </>
            )}

            <h4 className="mb-3 mt-4 text-primary fw-semibold">Labour — Destination Address</h4>

            <div className="mb-3">
              <div className="form-check form-switch">
                <input className="form-check-input" type="checkbox" id="requiredLaboursDest_field" checked={requiredLaboursDestination} onChange={(e) => setRequiredLaboursDestination(e.target.checked)} />
                <label className="form-check-label" htmlFor="requiredLaboursDest_field">
                  {requiredLaboursDestination ? 'Labour required: ON' : 'Labour required: OFF'}
                </label>
              </div>
            </div>

            {requiredLaboursDestination && (
              <>
                <div className="mb-3">
                  <label className="form-label">Number of Labours</label>
                  <input type="number" className="form-control" value={noOfLaboursDestination} onChange={(e) => setNoOfLaboursDestination(e.target.value)} required />
                </div>
                <div className="mb-3">
                  <label className="form-label">Loading Floors</label>
                  <input type="number" className="form-control" value={buildingFloorsDestination} onChange={(e) => setBuildingFloorsDestination(e.target.value)} required />
                </div>
                <div className="mb-3">
                  <label className="form-label">Cargo Lift Available?</label>
                  <div className="form-check form-switch">
                    <input className="form-check-input" type="checkbox" checked={cargoLiftDestination} onChange={(e) => setCargoLiftDestination(e.target.checked)} />
                  </div>
                </div>
              </>
            )}

            <button id="shipping_btn" type="submit" className="btn btn-primary w-100 py-2 mt-4">
              Continue
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default CreateLocalBooking;